export const ALLINGA_URL = "https://www.allinga.fraunhofer.de/";
export const RELEASE_NOTES_URL = "/ReleaseNotes.md";
export const SSML_DOCS_EN_URL = "/ssml-en.md";
export const SSML_DOCS_DE_URL = "/ssml-de.md";
export const DEFAULT_PRIVACY_URL = "https://www.allinga-plattform.de/privacy";
export const DEFAULT_IMPRINT_URL = "https://www.allinga-plattform.de/imprint";
